import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import ProposalSearchModal from './ProposalSearchModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import { ProposalResponse } from 'services/proposal';
import { FinContractResponse } from 'services/fincontract';

export type ProposalSelectedType = {
  ctrid?: number;
  propreference?: string;
  clientname?: string;
  values?: ProposalResponse | FinContractResponse;
};

export type ProposalSelectProps = {
  prcode?: string;
  onChange?: any;
  onSelected?: (value: ProposalSelectedType) => void;
  value?: ProposalSelectedType;
  phase?: string;
  PropOrProd?: string;
  hideFilters?: boolean;
  hideAction?: boolean;
  onlyctrid?: boolean;
  clear?: boolean;
  display?: boolean;
  style?: any;
  isCreate?: boolean;
  valueToDisplay?: ProposalSelectedType;
  objectName?: string;
  flagPropWithCtreference?: boolean;
};

const ProposalSelect = ({
  onChange = noop,
  onSelected,
  value,
  phase,
  prcode,
  clear,
  PropOrProd,
  hideFilters,
  hideAction,
  onlyctrid,
  display,
  style,
  isCreate,
  valueToDisplay,
  objectName,
  flagPropWithCtreference,
}: ProposalSelectProps) => {

  const [Params, setParams] = useState<ProposalSelectedType>({
    ctrid: value?.ctrid,
    propreference: value?.propreference,
    clientname: value?.clientname,
  });
  const { visible, close, open } = useModalState(false);
  const [onClear, setonClear] = useState(false);
  const [tpModal, setTpModal] = useState(false);

  const handleSelect = (item: any) => {
    onlyctrid ? onChange(item.ctrid) : onChange(item);

    if (PropOrProd === 'PROD' || flagPropWithCtreference) {
      setParams({
        propreference: item?.ctreference,
        clientname: item.clientname,
        ctrid: item?.ctrid,
      });
      if (onSelected)
        onSelected({
          propreference: item?.ctreference,
          clientname: item.clientname,
          ctrid: item?.ctrid,
          values: item
        });
    } else {
      if (onSelected)
        onSelected({
          propreference: item?.propreference,
          clientname: item.clientname,
          ctrid: item?.ctrid,
          values: item
        });
      setParams({
        propreference: item?.propreference,
        clientname: item.clientname,
        ctrid: item?.ctrid,
      });
    }
    setonClear(true);
    close();
  };
  const handleClear = () => {
   
    // Clear the input and reset Params
    setParams({
      propreference: undefined,
      clientname: undefined,
      ctrid: undefined,
    });
    onChange(undefined); // Notify parent of cleared state
  };

  useEffect(() => {
    console.log('clearde', value)
    setonClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if ((typeof value === 'number') && value === 0) {
      setParams({
        propreference: undefined,
        clientname: undefined,
        ctrid: undefined,
      });
   }
 
  }, [clear,value]);
  const [visibleModal, setvisibleModal] = useState(false);
  return (
    <>
      <div style={style}>
        {display ? (
          <Typography.Link
            onClick={() => {
              setTpModal(true);
              setvisibleModal(true);
            }}
            title="Open details"
            ellipsis
          >
            {valueToDisplay?.ctrid
              ? `${valueToDisplay.propreference ?? ''}  -  ${
                  valueToDisplay.clientname ?? ''
                }`
              : onClear && !value?.ctrid
              ? Params?.ctrid && value !== isNil
                ? `${Params.propreference ?? ''}  -  ${Params.clientname ?? ''}`
                : phase === undefined
                ? 'Select a Proposal'
                : 'Select a Contract'
              : value?.ctrid && value !== isNil
              ? `${value.propreference ?? ''}  -  ${value.clientname ?? ''}`
              : phase === undefined
              ? 'Select a Proposal'
              : 'Select a Contract'}
          </Typography.Link>
        ) : (
          <AppSearchInput
            onSearch={() => {
              open();
              localStorage.removeItem('searchParams');
              localStorage.removeItem('searchParams_components');
              }}
              
              onClear={handleClear} // Update the onClear handler
            value={
              <Typography.Link
                onClick={() => {
                  setTpModal(true);
                  setvisibleModal(true);
                }}
                title="Open details"
                ellipsis
              >
                {onlyctrid && !value?.ctrid
                  ? Params?.ctrid && value !== isNil && value !== undefined
                    ? `${Params.propreference ?? ''}  -  ${
                        Params.clientname ?? ''
                      }`
                    : isCreate
                    ? 'Select a Proposal'
                    : 'Select a Contract'
                  : value?.ctrid && value !== isNil
                  ? `${value.propreference ?? ''}  -  ${value.clientname ?? ''}`
                  : isCreate
                  ? 'Select a Proposal'
                  : 'Select a Contract'}
              </Typography.Link>
            }
          />
        )}
      </div>
      <ProposalSearchModal
        prcode={prcode}
        phase={phase}
        visible={visible}
        onCancel={close}
        setProposal={handleSelect}
        PropOrProd={PropOrProd}
        hideAction={hideAction}
        clientname={objectName}
        flagPropWithCtreference={flagPropWithCtreference}
      />
      {value?.ctrid ? (
        <ProposalModal
          onCancel={() => {
            setvisibleModal(false);
          }}
          visible={visibleModal}
          onSuccess={() => setvisibleModal(true)}
          title=""
          iscreate={false}
          ctrid={onlyctrid ? Number(value) ?? 0 : value?.ctrid ?? 0}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default ProposalSelect;
